import styled from 'styled-components';
import MuiSnackbar from '@material-ui/core/Snackbar';

export const StyledSnackbar = styled(MuiSnackbar)`
  .MuiAlert-message {
    font-family: 'Montserrat', sans-serif;
  }
`;
